import { useBoostedJobs_job$key } from '#app/__generated__/relay/useBoostedJobs_job.graphql.js';
import { graphql, useFragment } from '@contra/relay';

export const useBoostedJobs = ({
  jobRef,
}: {
  jobRef?: null | useBoostedJobs_job$key;
}) => {
  const data = useFragment<useBoostedJobs_job$key>(
    graphql`
      fragment useBoostedJobs_job on Job {
        id
        status
        boostRequested
        boostRemainingDays
        expertProgram {
          id
        }
      }
    `,
    jobRef,
  );

  if (!data) {
    return {
      boostRemainingDays: null,
      boostRequested: false,
      canBeBoosted: false,
      isActiveJobBoost: false,
    };
  }

  const isActiveJobBoost = Boolean(
    (data?.boostRequested &&
      (data?.boostRemainingDays === null || data?.boostRemainingDays > 0)) ||
      (data?.boostRemainingDays && data.boostRemainingDays > 0),
  );
  const isExpertProgramJob = Boolean(data?.expertProgram?.id);

  const canBeBoosted =
    data?.status !== 'CLOSED' && !isExpertProgramJob && !isActiveJobBoost;

  return {
    boostRemainingDays: data?.boostRemainingDays,
    boostRequested: isActiveJobBoost ? true : data?.boostRequested,
    canBeBoosted,
    isActiveJobBoost,
  };
};
